module.exports = __webpack_public_path__ + "img/icon-sports-black.81e64725.svg";